export const INLINE_MESSAGE_TYPES = {
  error: 'error',
  warning: 'warning',
  info: 'info',
  sublabel: 'sublabel',
  disabled: 'disabled',
};
